import '@/styles/pages/StoreMgmt/registration/RegistrationPage.scss';
import { Box, CircularProgress, Tooltip } from '@mui/material';
import { CastConnected, Delete } from '@mui/icons-material';
import { useAppContext } from '@/provider/contexts';
import { useRegistrationButtonState } from '@/hooks/registration/useRegistrationButtonState';
import { useRegistrationLifecycleState } from '@/provider/registration/registrationLifecycleContext';
import { useRegistrationState } from '@/provider/registration/registrationContext';
import { useTranslation } from 'react-i18next';
import AddApDialog from '@/components/registration/addAp/AddApDialog';
import AddTagDialog from '@/components/registration/addTag/AddTagDialog';
import BaseButton from '@/components/ui/BaseButton';
import BasePaper from '@/components/ui/BasePaper';
import BaseTitle from '@/components/ui/BaseTitle';
import DeleteDialog from '@/components/registration/DeleteDialog';
import DeviceTab from '@/components/registration/DeviceTab';
import NoStoreSelectionBlock from '@/components/store/NoStoreSelectionBlock';
import RegistrationMode from '@/components/registration/registrationMode/RegistrationMode';
import SearchBar from '@/components/form/SearchBar';
import ToggleApLockDialog from '@/components/registration/toggleApLock/ToggleApLockDialog';

const RegistrationPage = () => {
    const { t } = useTranslation('common');
    const { manageStoreId } = useAppContext();
    const { state, dispatch } = useRegistrationState();
    const buttonState = useRegistrationButtonState();
    const { refreshTable } = useRegistrationLifecycleState();

    const searchHandler = (keyword?: string) => {
        dispatch({ type: 'SET_SEARCH_MAC', payload: keyword as string });
        void refreshTable({
            tab: state.currentTab,
            searchMac: keyword,
            clearSelected: true,
        });
    };

    const deleteClickHandler = () => {
        dispatch({ type: 'TOGGLE_DIALOG', payload: { dialog: 'isDeleteOpen', isOpen: true } });
    };

    return (
        <>
            <BasePaper isFullHeight={false} className="registration-page">
                <Box
                    sx={{
                        display: { xs: 'block', lg: 'flex' },
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <BaseTitle icon={<CastConnected />} title={t('Store Registration')} />
                </Box>
                {manageStoreId ? (
                    <>
                        <Box className="actions-box">
                            <Box className="actions-box-left">
                                <SearchBar
                                    value={state.searchMac}
                                    onSearch={searchHandler}
                                    sx={{ my: 2, width: { xs: '100%', sm: 200, md: 300 } }}
                                    placeholder={t('Search by MAC')}
                                ></SearchBar>
                                <Box className="actions-buttons">
                                    <Tooltip
                                        title={t(buttonState.delete.tooltip)}
                                        disableHoverListener={buttonState.delete.status}
                                    >
                                        <span>
                                            <BaseButton
                                                variant="contained"
                                                color="primary"
                                                startIcon={<Delete />}
                                                onClick={deleteClickHandler}
                                                disabled={!buttonState.delete.status}
                                            >
                                                {t('Delete')}
                                            </BaseButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </Box>
                            <Box className="actions-box-right">
                                <RegistrationMode />
                            </Box>
                        </Box>
                        {state.loadingState.storeStateLoading ? (
                            <Box
                                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}
                            >
                                <CircularProgress />
                            </Box>
                        ) : (
                            <DeviceTab />
                        )}
                    </>
                ) : (
                    <NoStoreSelectionBlock />
                )}
            </BasePaper>

            {/* AP Dialog */}
            <AddApDialog />
            {/* Tag Dialog */}
            <AddTagDialog />
            {/* Unlock Dialog */}
            <ToggleApLockDialog />
            {/* Delete Dialog */}
            <DeleteDialog />
        </>
    );
};

export default RegistrationPage;
